
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.61 0h.127c.351 0 .577 0 .798.02A4.75 4.75 0 019.01 1H15.308c.409 0 .687 0 .931.032a3.75 3.75 0 013.248 3.427 3 3 0 01.77.503c.1.088.193.182.281.28.529.588.754 1.303.86 2.144.102.812.102 1.838.102 3.111v2.31c0 1.837 0 3.293-.153 4.432-.158 1.172-.49 2.121-1.238 2.87-.749.748-1.698 1.08-2.87 1.238-1.14.153-2.595.153-4.433.153H8.694c-1.838 0-3.294 0-4.433-.153-1.172-.158-2.121-.49-2.87-1.238-.748-.749-1.08-1.698-1.238-2.87C0 16.099 0 14.644 0 12.806V5.7v-.09c0-.797 0-1.303.082-1.74A4.75 4.75 0 013.87.081C4.307 0 4.813 0 5.61 0zm12.287 4.078a2.25 2.25 0 00-1.853-1.559c-.134-.017-.306-.019-.794-.019h-4.689c.643.64.935.906 1.266 1.09.218.121.449.217.689.286.413.117.866.124 2.062.124h.425c1.162 0 2.119 0 2.894.078zM5.7 1.5c-.917 0-1.271.003-1.553.056a3.25 3.25 0 00-2.59 2.591C1.502 4.43 1.5 4.783 1.5 5.7v7.05c0 1.907.002 3.262.14 4.29.135 1.005.389 1.585.812 2.008.423.423 1.003.677 2.009.812 1.028.138 2.382.14 4.289.14h4c1.907 0 3.262-.002 4.29-.14 1.005-.135 1.585-.389 2.008-.812.423-.423.677-1.003.812-2.009.138-1.027.14-2.382.14-4.289v-2.202c0-1.336-.001-2.268-.09-2.975-.087-.689-.246-1.06-.487-1.328a2.238 2.238 0 00-.168-.168c-.268-.241-.64-.4-1.328-.487-.707-.089-1.639-.09-2.975-.09h-.484c-1.048 0-1.724 0-2.363-.182-.35-.1-.689-.24-1.008-.417-.58-.324-1.058-.801-1.8-1.543L9.22 3.28l-.55-.55a8.03 8.03 0 00-.503-.482 3.25 3.25 0 00-1.771-.734A8.029 8.029 0 005.7 1.5zM11 8.75a.75.75 0 01.75-.75h5a.75.75 0 010 1.5h-5a.75.75 0 01-.75-.75z","fill":"#624DE3"}})])
          )
        }
      }
    